import { Box, Skeleton, Stack } from "@mui/material";

import { MapPanel } from "~/modules/map/components/MapPanel";

import { WeatherReportsHeader } from "./WeatherReportsHeader";
import WeatherReportsProtocolSummarySkeleton from "./WeatherReportsProtocolSummary/WeatherReportsProtocolSummarySkeleton";
import { WeatherReportsTableHeader } from "./WeatherReportsTableHeader";
import WeatherReportTableRowSkeleton from "./WeatherReportTableRow/WeatherReportTableRowSkeleton";

type WeatherReportsPanelSkeletonProps = {
    backHref: string;
};

export function WeatherReportsPanelSkeleton({ backHref }: WeatherReportsPanelSkeletonProps) {
    return (
        <MapPanel>
            <WeatherReportsHeader backHref={backHref} />

            <WeatherReportsProtocolSummarySkeleton />

            <Box
                sx={theme => ({
                    display: "grid",
                    gridTemplateColumns: "2fr 1fr 1fr auto",
                    borderBottom: `1px solid ${theme.palette.divider}`,
                })}
            >
                <WeatherReportsTableHeader />

                {[1, 2, 3, 4, 5].map(i => (
                    <WeatherReportTableRowSkeleton key={i} />
                ))}
            </Box>

            <Stack padding={2} rowGap={2}>
                <Skeleton variant="rectangular" width="100%" height={60} />
                <Skeleton variant="rectangular" width="100%" height={40} />
            </Stack>
        </MapPanel>
    );
}
